import { useEffect, useState } from 'react';
import { AppState, type AppStateStatus } from 'react-native';

export default function useAppState(): AppStateStatus | null {
  const [appState, setAppState] = useState<AppStateStatus | null>(
    AppState.currentState,
  );

  useEffect(() => {
    const handler = (status: AppStateStatus) => {
      setAppState(status);
    };
    const subscriber = AppState.addEventListener('change', handler);
    return () => subscriber.remove();
  }, []);

  return appState;
}
